import React, { createContext, useEffect, useState } from "react";
import BackendService from "../../services/BackendService";
import { attributeDetails } from "./attributeDetails";
import { getAttributeRow } from "./fsaMapHelper";

export const FSAMapDataContext = createContext({});

export function FSAMapDataProvider({ children }) {
  const [page, setPage] = useState(1);
  const [fsas, setFSAs] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(false);
  const [awaitingResponse, setAwaitingResponse] = useState(false);
  const [validFile, setValidFile] = useState(false);
  const [postResponse, setPostResponse] = useState({});
  const [highlightedFsa, setHighlightedFsa] = useState(null);
  const [fsaAttributesState, setFsaAttributesState] = useState({});

  useEffect(() => {
    if (!fsas || fsas.length === 0) return;

    const backendService = new BackendService();

    fsas.forEach((fsa) => {
      const state_ = fsaAttributesState[fsa];

      if (state_?.loading || state_?.data || state_?.error) return;

      setFsaAttributesState((prevState) => ({
        ...prevState,
        [fsa]: { loading: true, data: null, error: null },
      }));

      backendService
        .fetchAttributesForFSA(fsa)
        .then((res) => {
          if (res?.error) {
            throw new Error(res.error);
          }
          setFsaAttributesState((prevState) => ({
            ...prevState,
            [fsa]: {
              loading: false,
              data: attributeDetails
                .map((i) => getAttributeRow(i, res))
                .filter((i) => i !== null),
              error: null,
            },
          }));
        })
        .catch((error) => {
          console.error(`Error fetching attributes for FSA: ${fsa}`, error);
          setFsaAttributesState((prevState) => ({
            ...prevState,
            [fsa]: { loading: false, data: null, error: error.message },
          }));
        });
    });

    setHighlightedFsa(fsas[fsas.length - 1]);
  }, [fsas, fsaAttributesState]);

  return (
    <FSAMapDataContext.Provider
      value={{
        page,
        setPage,
        fsas,
        setFSAs,
        open,
        setOpen,
        message,
        setMessage,
        postResponse,
        setPostResponse,
        awaitingResponse,
        setAwaitingResponse,
        validFile,
        setValidFile,
        fsaAttributesState,
        highlightedFsa,
        setHighlightedFsa,
      }}
    >
      {children}
    </FSAMapDataContext.Provider>
  );
}
